import config from "../../../config";

function openNewWindowPopup(url: string) {
  window.open(
    url,
    "_blank",
    "location=no,height=780,width=520,scrollbars=yes,status=no,toolbar=no"
  );
}

export default function openGoogleSignInPopup({
  onResponse,
}: {
  onResponse: (
    data:
      | { ok: true; redirectionUrl?: string }
      | { ok: false; failure: { status: 403 | 404 } }
  ) => void;
}) {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const demoMockUserIdQueryString =
    getDemoMockUserIdQueryString(urlSearchParams);
  const acquisitionSourceQueryString =
    getAcquisitionSourceQueryString(urlSearchParams);
  const acquisitionCampaignQueryString =
    getAcquisitionCampaignQueryString(urlSearchParams);
  const queryStrings = [
    demoMockUserIdQueryString,
    acquisitionSourceQueryString,
    acquisitionCampaignQueryString,
  ].filter(Boolean);
  const queryString = queryStrings.length ? `?${queryStrings.join("&")}` : "";
  openNewWindowPopup(
    `${config.API_HOST}/redirection/google/oauth2${queryString}`
  );
  const onReceiveMessage = (e: MessageEvent) => {
    const { type, data } = e.data;
    if (type !== "GOOGLE/AUTHORIZATION") return;
    onResponse(data);
    window.removeEventListener("message", onReceiveMessage, false);
  };
  window.addEventListener("message", onReceiveMessage, false);
}

function getDemoMockUserIdQueryString(urlSearchParams: URLSearchParams) {
  const demo_mock_user_id = urlSearchParams.get("demo_mock_user_id");
  if (demo_mock_user_id) {
    return `demoMockUserId=${demo_mock_user_id}`;
  }
  return "";
}

function getAcquisitionSourceQueryString(urlSearchParams: URLSearchParams) {
  const utm_source = urlSearchParams.get("utm_source");
  if (utm_source) {
    return `acquisitionSource=${utm_source}`;
  }
  return "";
}

function getAcquisitionCampaignQueryString(urlSearchParams: URLSearchParams) {
  const utm_campaign = urlSearchParams.get("utm_campaign");
  if (utm_campaign) {
    return `acquisitionCampaign=${utm_campaign}`;
  }
  return "";
}
